import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

var firebaseConfig = {
    apiKey: "AIzaSyCXvKKwMmMujxG6sOwSNgpE7TjIpMga5SM",
    authDomain: "catalogo-flexores.firebaseapp.com",
    projectId: "catalogo-flexores",
    storageBucket: "catalogo-flexores.appspot.com",
    messagingSenderId: "520737757132",
    appId: "1:520737757132:web:4d40bbcba2b11f317a6f69",
    measurementId: "G-VCDDDKE6PF"

};

const fb = firebase.initializeApp(firebaseConfig);
export const db = fb.firestore();
export const auth = fb.auth();

export const apiKeyGeoapify = "e0ca4892f1c5486fa6bed30da3b22979"